import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {HandleErrorService} from '../handleError.service';

@Injectable({
  providedIn: 'root'
})
export class DataUtilisateurService extends HandleErrorService {
  apiUser = environment.globalUrlDomaine + '/records/user';
  apiUserSoftgate = environment.globalApiUrl + 'api/user';

  getUser() {
    return this.http.get<any>(this.apiUser + '?is_active,1', environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  // getUser() {
  //   return this.http.get<any>(this.apiUserSoftgate + '/get-all', environment.httpOptions).pipe(
  //     catchError(this.handleError)
  //   );
  // }
  getRoles() {
    return this.http.get<any>(environment.globalUrlDomaine + '/records/roles', environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  getUserConcession(concessionId: string) {
    return this.http.get<any>(environment.globalUrlDomaine + '/records/user_concession' + '?filter=concession_id,eq,' + concessionId , environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  getUserById(id) {
    return this.http.get<any>(this.apiUser + '/' + id , environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  getUserByIdWithNotificationExclusion(userId: number) {
    return this.http.get<any>(this.apiUser + '/' + userId + '?join=user_notification_exclusion', environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  createUser(post) {
    const jsonPost = JSON.stringify(post);
    return this.http.post<any>(environment.globalApiUrl + 'api/register', jsonPost, environment.httpOptionsSGApi).pipe(
      catchError(this.handleError)
    );
  }
  updateUser(post) {
    const jsonPost = JSON.stringify(post);
    return this.http.put<any>(environment.globalApiUrl + 'api/register', jsonPost, environment.httpOptionsSGApi).pipe(
      catchError(this.handleError)
    );
  }
  resetSecret(post) {
    const jsonPost = JSON.stringify(post);
    return this.http.put<any>(environment.globalApiUrl + 'api/reset-secret', jsonPost, environment.httpOptionsSGApi).pipe(
      catchError(this.handleError)
    );
  }

  deleteUser(post) {
    const jsonPost = JSON.stringify(post);
    return this.http.put<any>(environment.globalApiUrl + 'api/delete/user', jsonPost, environment.httpOptionsSGApi).pipe(
      catchError(this.handleError)
    );
  }
}
